export const REPORT_PARAMS = {
  TEXT: 'TEXT',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  NUMERIC: 'NUMERIC',
  VEHICLE: 'VEHICLE',
  USER: 'USER',
  DIVISION: 'DIVISION',
  INTERVAL: 'INTERVAL',
  DATE_INTERVAL: 'DATE_INTERVAL',
};

export const EMPTY_NAME = 'Без названия';
export const EMPTY_ERROR = 'Поле не может быть пустым';

export const fileType = ['PDF', 'XLSX', 'DOCX', 'HTML'].map((name) => ({
  value: name,
  name,
}));
